function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-/-Kostenbesparing-euros",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kostenbesparing-tot-heden",
  transform: "translate(1.000000, 1.000000)",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4",
  transform: "translate(0.000000, 6.000000)",
  stroke: "#485156"
}, /*#__PURE__*/React.createElement("g", {
  id: "wedding-money-piggy",
  transform: "translate(0.000000, 0.800000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.1875,10.453125 C11.5240485,10.453125 11.796875,10.7259515 11.796875,11.0625",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.578125,11.0625 C10.578125,10.7259515 10.8509515,10.453125 11.1875,10.453125",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.1875,11.671875 C10.8509515,11.671875 10.578125,11.3990485 10.578125,11.0625",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.796875,11.0625 C11.796875,11.3990485 11.5240485,11.671875 11.1875,11.671875",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 8.767875,
  y1: 26.8315,
  x2: 7.53125,
  y2: 31.78125,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 25.79625,
  y1: 26.838,
  x2: 27.03125,
  y2: 31.78125,
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.655875,2.9635 L10.46275,0.303375 C10.120778,0.0172794045 9.64974502,-0.0589330522 9.23500316,0.104727338 C8.8202613,0.268387728 8.52820162,0.64572254 8.47375,1.08825 L7.903375,5.656125 C5.69386443,7.32518411 4.05875392,9.64069141 3.225,12.28125 L0.21875,12.28125 L0.21875,22.03125 L4.265,22.03125 C6.96796199,26.6372874 11.9414084,29.4313584 17.28125,29.34375 C25.359125,29.34375 31.9062582,23.341 31.9062582,15.9375 C31.9067243,15.5304972 31.8866571,15.1237298 31.846125,14.71875",
  id: "Path"
}))), /*#__PURE__*/React.createElement("g", {
  id: "currency-euro-circle",
  transform: "translate(18.000000, 0.000000)",
  stroke: "#425CD4"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 9,
  cy: 9,
  r: 8.59090909
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.2272727,12.6818182 C7.85454545,12.6818182 6.54545455,11.3727273 6.54545455,9 C6.54545455,6.62727273 7.85454545,5.31818182 10.2272727,5.31818182",
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.31818182,
  y1: 7.77272727,
  x2: 10.2272727,
  y2: 7.77272727,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.31818182,
  y1: 10.2272727,
  x2: 10.2272727,
  y2: 10.2272727,
  id: "Path"
}))));
function SvgPiggyEuros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "43px",
    viewBox: "0 0 40 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Kostenbesparing euros") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiggyEuros);
export default __webpack_public_path__ + "static/media/Piggy_euros.6fabbbc832d69d5ab9242811ba1d7efc.svg";
export { ForwardRef as ReactComponent };